<template>
  <div class="layout">
    <header>
      <div class="module-nav">
        <div class="nav flex-row">
          <p style="cursor: pointer" @click="returnHome()" class="logo">
            <!-- <img src="@/assets/home/logo.png" alt=""> -->
            <img style="width:96px" src="@/assets/home/new-logo.png" alt="">
          </p>
          <div>
            <!-- :default-active="activeIndex" -->
            <el-menu ref="modulenav" class="el-menu-demo" mode="horizontal" text-color="#252728"
              active-text-color="#3056d9">
              <div class="plate-nav menu-item" v-for="item in navList" :key="item.index" :index="item.index"
                @click="handleSelect(item.index)" >
                {{item.title}}
                <div :class="activeIndex == item.index?'is-active':''"></div>
                <!-- <el-dropdown v-if="item.index === '4'" @command="goSomepage">
                  <span class="el-dropdown-link">
                    活动<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command='/HCMegagame'>海创大赛</el-dropdown-item>
                    <el-dropdown-item command='/firmElect'>企业评选</el-dropdown-item>
                    <el-dropdown-item command='/webAnnualMeeting'>网络年会</el-dropdown-item>
                    <el-dropdown-item command='/elseActive'>其他活动</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->
              </div>
            </el-menu>
          </div>
          <div class="search-user-nav">
            <div class="search-nav" @click="goSomepage('/standSearch')">
              站内搜索
            </div>

            <div class="user-nav">
              <span v-if="istoken === null" @click="goSomepage('/login')">登录</span>
              <el-dropdown @command="goSomepage" v-if="istoken !== null">
                <span class="el-dropdown-link">
                  用户中心
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command='/registrationRecord'>报名记录</el-dropdown-item>
                  <el-dropdown-item command='/surveyInfo' v-if="userType === 'garden' ">园区后台</el-dropdown-item>
                  <el-dropdown-item command='/changePassword'>修改密码</el-dropdown-item>
                  <el-dropdown-item command='/logOut'>退出登录</el-dropdown-item>
                  <!-- <el-dropdown-item command='/logOut' v-if="istoken !== null">退出登录</el-dropdown-item>
                                    <el-dropdown-item command='/logOut' v-if="istoken === null">去登录</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="main">
      <!-- 子路由出口 -->
      <router-view></router-view>
    </div>

    <footer class="public-footer">
      <div class="contact-alliance">
        <div class="contact-way">
          <p>联系我们</p>
          <p class="contact-info down-style">
            <span class="call">电话：{{joinAlliance.phone}}</span>
            <span class="address">地址：{{joinAlliance.address}}</span>
          </p>
          <p class="contact-info">
            <span class="call">邮箱：{{joinAlliance.email}}</span>
            <span class="address">邮编：{{joinAlliance.mailCode}}</span>
          </p>
        </div>
        <div class="QR">
          <img src="@/assets/home/QR.png" alt="">
        </div>
      </div>

      <div class="unit ">
        <!-- <div class="sum-unit">
                  <div class="alliance-unit">
                      <span>联盟指导单位</span>
                      <el-divider direction="vertical"></el-divider>
                      <p class="line-show">
                        <span class="UnitSty"
                          style="padding:0 8px;"
                          v-for="(item, index) in allianceAdviserUnit"
                          :key="index"
                          @click="goLinkPage(item.link)">
                          {{ item.title}}
                        </span>
                      </p>
                      <el-divider class="col-line" direction="vertical"></el-divider>
                  </div>

                  <div class="alliance-unit">
                      <span>联盟成员单位</span>
                      <el-divider direction="vertical"></el-divider>
                      <p class="line-show">
                        <span class="UnitSty"
                          v-for="(item, index) in allianceMemberUnit"
                          :key="index"
                          @click="goLinkPage(item.link)">
                          {{item.title}}
                        </span>
                      </p>
                      <el-divider class="col-line" direction="vertical"></el-divider>
                  </div>
                </div> -->

        <div class="sum-unit">
          <p>联盟指导单位 <el-divider direction="vertical"></el-divider>
          </p>
          <!-- <el-divider direction="vertical"></el-divider> -->
          <p class="line-show">
            <span class="UnitSty" style="padding:0 8px;" v-for="(item, index) in allianceAdviserUnit" :key="index"
              @click="goLinkPage(item.link)">
              {{ item.title}}
            </span>
          </p>
        </div>

        <div class="more">
          <button class="more-btn" @click="morebtn">+ 更多</button>
        </div>
      </div>

      <div class="copyright">
        <p>京ICP备12032954号-1 京公网安备11010802015934号</p>
        <p>Copyright © 2015-2025 北京海外学人科技发展中心 版权所有</p>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'layout',
    inject: ['reload'], // 引入方法
    props: {

    },
    components: {

    },
    data() {
      return {
        istoken: '',
        activeIndex: '1',
        userType: '',
        navList: [{
            title: '首页',
            index: '1',
            href: '/home'
          },
          {
            title: '通知公告',
            index: '2',
            href: '/inform'
          },
          {
            title: '新闻动态',
            index: '3',
            href: '/information'
          },
          // {
          //   title: '',
          //   index: '4'
          // },
          {
            title: '孵化基地',
            index: '5',
            href: '/basePage'
          },
          // {
          //   title: '园区',
          //   index: '6',
          //   href: '/garden'
          // },
          // {
          //   title: '企业',
          //   index: '7',
          //   href: '/firm'
          // },
          // {
          //   title: '服务',
          //   index: '8',
          //   href: '/serve'
          // },
          {
            title: '政策法规',
            index: '9',
            href: '/policy'
          },
          {
            title: '杂志年鉴',
            index: '10',
            href: '/magazine'
          },
          {
            title: '关于我们',
            index: '11',
            href: '/serveSystem'
          }
        ],
        serveUrl: '', // 服务跳转链接
        // 联系方式
        joinAlliance: {
          call: '010-82699858  82698998转8806',
          address: '北京海淀区中关村大街甲59号文化大厦401室',
          email: 'lipeng@liuchuanglianmeng.com',
          postcode: '100872',
          QRurl: require('@/assets/home/QR.png') // 图片地址
        },
        // 联盟指导单位
        allianceAdviserUnit: ['国家教育部留学服务中心 '],
        visualAdviserUnit: [],
        // 联盟成员单位
        allianceMemberUnit: ['北京理工留学人员创业园 '],
        visualMemberUnit: []
      }
    },
    computed: {

    },
    created() {
      console.log(window.location.href)
      // this.getNewActiveIndex(window.location.href)
      this.getUserType()
      this.getFooterData()
    },
    mounted() {
      this.istoken = localStorage.getItem('tokenStr') || sessionStorage.getItem('tokenStr')

      // const _this = this // 很关键是要把父路由的vue实例赋给_this
      // this.$bus.$on('changeNav', function () {
      //   // console.log('返回上一页')
      //   // _this.getNewActiveIndex()
      // })
    },
    methods: {
      returnHome() {
        this.$router.push('/home')
      },
      // 用户类型加载
      getUserType() {
        if (localStorage.getItem('tokenStr')) {
          this.userType = localStorage.getItem('userType');
          return false
        }
        if (sessionStorage.getItem('tokenStr')) {
          this.userType = sessionStorage.getItem('userType');
          return false
        }
      },

      // 个人中心、活动页面跳转页面
      goSomepage(path) {
        this.activeIndex = '0'
        this.$router.push({
          path: path
        })
      },

      async getDetail() {
        try {
          const res = await this.$get(this.$url.serve.tbService)
          const {
            code,
            msg,
            data
          } = res.data
          if (code === 200) {
            // this.detail = res.data.data
            this.serveUrl = data.url
          } else {
            this.$message.error(msg)
          }
        } catch (err) {
          console.log(err)
        }
      },

      // 导航跳转页面
      handleSelect(key) {
        console.log(key)
        if (key === '8') {
          this.getDetail()
          setTimeout(() => {
            if (this.serveUrl === null) {
              return
            }
            // console.log(this.serveUrl,'serveurl')
            if (this.serveUrl.indexOf('https://') !== -1) {
              this.serveUrl.replace('https://', 'http://')
              window.open(this.serveUrl)
            } else if (this.serveUrl.indexOf('http://') !== -1) {
              window.open(this.serveUrl)
            } else {
              window.open('http://' + this.serveUrl)
            }
          }, 500)
          // this.$router.push('/serve')
        } else {
          const href = this.navList.find(item=>item.index === key).href
          this.$router.push(href)
        }
      },

      // 获取布局页面底部数据
      async getFooterData() {
        try {
          const res = await this.$get(await this.$url.home.footerInfo)
          const {
            code,
            msg,
            data
          } = res.data
          if (code === 200 && data) {
            this.joinAlliance = data.contactUs

            data.institution.forEach(element => {
              if (element.name === '指导单位') {
                this.allianceAdviserUnit = element.value
              } else if (element.name === '联盟成员单位') {
                this.allianceMemberUnit = element.value
              }
            })
            // this.limitUnit()
          } else {
            this.$message.error(msg)
          }
        } catch (err) {
          console.log(err)
        }
      },

      // 限制单位展示数量
      // limitUnit () {
      //   if (this.allianceMemberUnit.length > 5) {
      //     this.visualMemberUnit = this.allianceMemberUnit.slice(0, 5)
      //   } else { this.visualMemberUnit = this.allianceMemberUnit }

      //   if (this.allianceAdviserUnit.length > 5) {
      //     this.visualAdviserUnit = this.allianceAdviserUnit.slice(0, 5)
      //   } else { this.visualAdviserUnit = this.allianceAdviserUnit }
      // },

      // 跳转链接页面
      goLinkPage(url) {
        // if (url === null) { return }
        // if (url.indexOf('https://') !== -1) {
        //   url.replace('https://', 'http://')
        //   window.open(url)
        // } else if (url.indexOf('http://') !== -1) {
        //   window.open(url)
        // } else {
        //   window.open('http://' + url)
        // }

        if (url) {
          window.open(url)
        }
      },

      // 联盟更多btn
      morebtn() {
        this.$router.push('/organization')
        // this.getNewActiveIndex()
      }
    }
  }
</script>

<style scoped lang="less">
  .myheader {
    width: 100%;
    background-color: #122f91;

    .welcome-nav {
      width: 1200px;
      height: 45px;
      margin: 0 auto;
      box-sizing: border-box;
      color: #fff;
      font-size: 14px;
      line-height: 45px;

      .search-user-nav {
        box-sizing: border-box;

        .search-nav,
        .user-nav {
          display: inline-block;
          cursor: pointer;

          img {
            vertical-align: middle;
            margin-right: 5px;
          }
        }

        .user-nav {
          margin-left: 70px;

          .el-dropdown-link {
            cursor: pointer;
            color: #fff;
          }
        }
      }

    }
  }

  .module-nav {
    position: relative;
    z-index: 99;
    background-color: #fff;
    box-shadow: 0px 2px 11px 0px rgba(142, 142, 142, 0.5) !important;
    .nav {
      width: 1200px;
      height: 70px;
      line-height: 70px;
      margin: 0 auto;
      background-color: #fff;
    }

    .logo {
      img {
        vertical-align: middle;
      }
    }

    .plate-nav {
      font-weight: 500;
      color: #252728;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;

      /deep/.el-dropdown {
        font-size: 16px;
        margin: -5px 0 0;
        padding: 0;
      }
    }

    .search-user-nav {
        box-sizing: border-box;

        .search-nav,
        .user-nav {
          display: inline-block;
          cursor: pointer;

          img {
            vertical-align: middle;
            margin-right: 5px;
          }
        }

        .user-nav {
          margin-left: 20px;

          .el-dropdown-link {
            cursor: pointer;
            color: #252728;
          }
        }
      }

    /deep/.el-submenu__icon-arrow {
      position: absolute;
      right: -25px;
      font-size: 16px;
      color: #000;
      margin-right: 5px;
    }

    /deep/.el-submenu__title {
      font-size: 16px;
      padding: 0;
      margin: 2px 12px 0 0;
    }

    /deep/.el-submenu__title:hover {
      background-color: #fff;
    }

    /deep/.el-menu--horizontal {
      border-bottom: 0;
      display: flex;
    }

    /deep/.menu-item {
      padding: 0;
      margin: 0 21px;
      position: relative;
	  cursor: pointer;
    }

    /deep/.el-menu-item:last-of-type {
      margin-right: 0;
    }

    /deep/.is-active {
      position: absolute;
      width: 40px;
      height: 4px;
      background-color: #3056D9;
      // border-bottom: 4px solid #3056D9 !important;
      border-radius: 0 0 2px 2px;
      bottom: 0;
      left: 50%;
      transform: translate(-50%);
    }
  }

  .public-footer {
    width: 100%;
    min-height: 385px;
    background-color: #122f91;
    color: #fff;
    font-size: 14px;
    overflow: hidden;

    .contact-alliance {
      width: 1200px;
      min-height: 169px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      padding: 36px 0 20px;
      border-bottom: 1px solid #243f99;

      .contact-way {
        font-size: 18px;

        .contact-info {
          position: relative;
          font-size: 14px;

          .call {
            display: inline-block;
            width: 300px;
          }

          .address {
            position: absolute;
            display: inline-block;
            width: 500px;
            left: 300px;
          }
        }

        .down-style {
          padding: 28px 0 22px;
        }

      }

      .QR img {
        width: 113px;
        height: 113px;
        vertical-align: middle;
      }
    }

    .unit {
      // background-color: khaki;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1200px;
      min-height: 10px;
      // line-height: 28px;
      // box-sizing: border-box;
      // padding: 25px 0 26px;
      margin: 0 auto;
      border-bottom: 1px solid #596db2;
      font-size: 14px;

      .sum-unit {
        // background-color: lavender;
        padding: 25px 0 25px;

        .line-show {
          // background-color: lightskyblue;
          padding-left: 100px;
          padding-right: 100px;
          margin-top: -24px;
        }

        .UnitSty {
          padding: 0 8px 0;
          cursor: pointer;
          // background-color: lightseagreen;
          line-height: 28px;
        }

        // .alliance-unit{
        //   background-color: lawngreen;
        //   width: 1000px;
        //   // min-height: 10px;
        //   // padding-bottom: 26px;
        //   // text-align: left;
        //   position: relative;
        //   .line-show{
        //     background-color: lightcoral;
        //     width: 880px;
        //     min-height: 20px;
        //     position: absolute;
        //     top: 0;
        //     left: 100px;
        //     // background-color: aqua;
        //     // overflow: hidden;
        //     // display: -webkit-box;
        //     // -webkit-line-clamp: 1; //显示行数
        //     // -webkit-box-orient: vertical;
        //   }
        //   .UnitSty{
        //     // display: inline-block;
        //     padding: 0 8px 0;
        //     cursor: pointer;
        //   }
        //   .col-line{
        //     position: absolute;
        //     right: 0;
        //     top: 7px;
        //   }
        // }
      }

      .more {
        .more-btn {
          width: 113px;
          height: 40px;
          background-color: #fff;
          border: 1px solid #fff;
          color: #000;
          font-size: 16px;
          text-align: center;
          // margin-top: 32px;
        }
      }
    }

    .copyright {
      width: 1200px;
      height: 104px;
      line-height: 26px;
      margin: 0 auto;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
    }
  }

  .main {
    width: 100%;
    min-height: 46vh;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #fff;
  }
</style>
